































import Vue from 'vue'
import { mapState } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import ProviderSelector from '@/components/ProviderSelector.vue'
import FormInput from '@/components/FormInput.vue'
import { ContextState, User, Config } from '@/store/context/contextTypes'
import JavascriptAPI from '@/utils/JavascriptAPI'
import { ProviderType } from '@/utils/identifyFields/providers/providerTypes'
import { providerLogo } from '@/utils/helpers'

// Vuex + typescript setup guide: https://codeburst.io/vuex-and-typescript-3427ba78cfa8

// define used modules
const _CONTEXT_: string = 'context'

@Component({
  props: {
    // provider: { type: Object, required: false },
    inputs: { type: Array, required: true },
    handleInputChange: { type: Function, required: true }
  },
  computed: {
    ...mapState({
      userWizardData: (state: any): User => state.context.userWizardData,
      identifyWizardStep: (state: any): User => state.context.identifyWizardStep,
      config: (state: any): object => state.context.config,
      isLoading: (state: any): boolean => state.context.isLoading,
      wizardIdentifyProvider: (state: any): ProviderType => state.context.wizardIdentifyProvider
    })
  },
  components: {
    FormInput,
    ProviderSelector
  }
})
export default class IdentityInputs extends Vue {
  config: Config
  identifyWizardStep: number
  wizardIdentifyProvider: ProviderType
  isLoading: Boolean
  @State('context') context: ContextState
  @Action('setIdentifyWizardStep', { namespace: _CONTEXT_ }) setIdentifyWizardStep: any

  get getProviderLogo () {
    return providerLogo(this.config.identifyProvider)
  }
}
